import { BrowserRouter, type BrowserRouterProps } from "react-router-dom";
import { useCallback } from "react";
import { useConfirmation } from "./ConfirmationProvider";

/** React Router's in-app leave warning; beforeunload remains browser-controlled. */
export function ConfirmationRouter(props: BrowserRouterProps) {
  const confirm = useConfirmation();
  const getUserConfirmation = useCallback(
    (message: string, callback: (allow: boolean) => void) => {
      void confirm({ title: "Leave this page?", message, actionLabel: "Leave page", destructive: true }).then(callback);
    },
    [confirm],
  );
  return (
    <BrowserRouter
      {...props}
      getUserConfirmation={getUserConfirmation}
    />
  );
}
